import { render, staticRenderFns } from "./IconRename.vue?vue&type=template&id=04e29b04&"
import script from "./IconRename.vue?vue&type=script&lang=js&"
export * from "./IconRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e29b04')) {
      api.createRecord('04e29b04', component.options)
    } else {
      api.reload('04e29b04', component.options)
    }
    module.hot.accept("./IconRename.vue?vue&type=template&id=04e29b04&", function () {
      api.rerender('04e29b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRename.vue"
export default component.exports